import * as FlatModels from '@medsurf/flat-models';
import * as EntityBaseActions from '../base/entity.base.actions';

// <editor-fold desc="Action Types">

/**
 * Action Types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetEntitySuccess = '[STORE | ENTITY | SLIDE_LAYER] Get Entity Success',
  GetEntitiesSuccess = '[STORE | ENTITY | SLIDE_LAYER] Get Entities Success',
  ModifyEntitySuccess = '[STORE | ENTITY | SLIDE_LAYER] Modify Entity Success',
  ModifyEntitiesSuccess = '[STORE | ENTITY | SLIDE_LAYER] Modify Entities Success',
  AddEntity = '[STORE | ENTITY | SLIDE_LAYER] Add Entity',
  UpdateEntity = '[STORE | ENTITY | SLIDE_LAYER] Update Entity',
  RemoveEntity = '[STORE | ENTITY | SLIDE_LAYER] Remove Entity',
  UndoSnapshot = '[STORE | ENTITY | SLIDE_LAYER] Undo Snapshot',
  RedoSnapshot = '[STORE | ENTITY | SLIDE_LAYER] Redo Snapshot',
  CleanUpSnapshots = '[STORE | ENTITY | SLIDE_LAYER] Clean Up Snapshots',
  SetLayerIndex = '[STORE | ENTITY | SLIDE_LAYER] Set Layer Index',
  RearrangeLayers = '[STORE | ENTITY | SLIDE_LAYER] Rearrange Layers',
  /**
   * Request
   */
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Get Entity Success
 */
export class GetEntitySuccess extends EntityBaseActions.GetEntitySuccess {
  public static readonly type = ActionTypes.GetEntitySuccess;
}

/**
 * Get Entities Success
 */
export class GetEntitiesSuccess extends EntityBaseActions.GetEntitiesSuccess {
  public static readonly type = ActionTypes.GetEntitiesSuccess;
}

/**
 * Modify Entity Success
 */
export class ModifyEntitySuccess extends EntityBaseActions.ModifyEntitySuccess {
  public static readonly type = ActionTypes.ModifyEntitySuccess;
}

/**
 * Modify Entities Success
 */
export class ModifyEntitiesSuccess extends EntityBaseActions.ModifyEntitiesSuccess {
  public static readonly type = ActionTypes.ModifyEntitiesSuccess;
}

/**
 * Add Entity
 */
export class AddEntity extends EntityBaseActions.AddEntity<FlatModels.LayerEntityModels.Layer> {
  public static readonly type = ActionTypes.AddEntity;
}

/**
 * Update Entity
 */
export class UpdateEntity extends EntityBaseActions.UpdateEntity<FlatModels.LayerEntityModels.Layer> {
  public static readonly type = ActionTypes.UpdateEntity;
}

/**
 * Remove Entity
 */
export class RemoveEntity extends EntityBaseActions.RemoveEntity<FlatModels.LayerEntityModels.Layer> {
  public static readonly type = ActionTypes.RemoveEntity;
}

/**
 * Undo Snapshot
 */
export class UndoSnapshot extends EntityBaseActions.UndoSnapshot {
  public static readonly type = ActionTypes.UndoSnapshot;
}

/**
 * Redo Snapshot
 */
export class RedoSnapshot extends EntityBaseActions.RedoSnapshot {
  public static readonly type = ActionTypes.RedoSnapshot;
}

/**
 * Clean Up Snapshots
 */
export class CleanUpSnapshots extends EntityBaseActions.CleanUpSnapshots {
  public static readonly type = ActionTypes.CleanUpSnapshots;
}

/**
 * Set Layer Index
 */
export class SetLayerIndex {
  public static readonly type = ActionTypes.SetLayerIndex;

  public constructor(public layerIndex: number) {
  }
}

/**
 * Rearrange Layers
 */
export class RearrangeLayers {
  public static readonly type = ActionTypes.RearrangeLayers;

  public constructor(public layers: FlatModels.LayerEntityModels.Layer[] | string[]) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

// </editor-fold>